import React from "react";

import { useContentContext } from "./context/content-context";
import ThemedPageWrapper from "./components/themed-page-wrapper";
import Section from "./components/section";
import Text from "./components/base/text";
import Link from "./components/base/link";

const NotFoundPage = () => {
  const { isHCP } = useContentContext();

  return (
    <ThemedPageWrapper>
      <Section>
        <Text>
          Click <Link href={isHCP ? "/hcp/" : "/"}>here</Link> to return to
          Furoscix.com{isHCP && "/HCP/"}
        </Text>
      </Section>
    </ThemedPageWrapper>
  );
};

export default NotFoundPage;
